var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-card',{staticClass:"ma-3",attrs:{"flat":""}},[_c('h5',{attrs:{"text-xs-center":""}},[_vm._v("Connections")])]),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-img',{attrs:{"src":_vm.getImage,"crossorigin":"anonymous"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }